import { useMemo } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { AppBar, Toolbar, useMediaQuery } from '@mui/material';

// project import
import AppBarStyled from './AppBarStyled';
import HeaderContent from './HeaderContent';
import IconButton from 'components/@extended/IconButton';

import {
  DRAWER_WIDTH,
  MINI_DRAWER_WIDTH,
  MenuOrientation,
//  ThemeMode,
} from 'config';
import useConfig from 'hooks/useConfig';
import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';

// assets
import { MdOutlineMenu, MdOutlineMenuOpen } from "react-icons/md";
//import { border, fontSize } from '@mui/system';
//import { size } from 'lodash';
//import { he } from 'date-fns/locale';






// ==============================|| MAIN LAYOUT - HEADER ||============================== //

const Header = () => {
  const theme = useTheme();
  const downLG = useMediaQuery(theme.breakpoints.down('lg'));
  const { menuOrientation } = useConfig();

  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const isHorizontal =
    menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  // Check if in development mode to add top margin for warning bar
  const isProduction = (process.env.REACT_APP_PRODUCTION || '').toUpperCase() === 'TRUE';
  const developmentBarOffset = isProduction ? 0 : '20px';




    
  // header content
  const headerContent = useMemo(() => <HeaderContent />, []);

  /*
  const iconBackColor =
    theme.palette.mode === ThemeMode.DARK ? 'background.default' : 'grey.100';
*/




  // common header
  const mainHeader = (
    <Toolbar
      sx={{
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.primary.main,
        //opacity: 0.50,
      }}
    >
      {!isHorizontal ? (  
        <IconButton
          aria-label='Abrir menú sidebar'
          onClick={() => handlerDrawerOpen(!drawerOpen)}
          edge='start'
          variant='light'
          size="large"
          sx={{
            p:0,
            m:0,
            color: theme.palette.primary.main,
            fontWeight: 'bold',
            bgcolor: 'transparent',
            //border: 1,
            ml: { xs: 0, lg: -2 },
          }}
        >
          {!drawerOpen ? <MdOutlineMenu size={30}/> : <MdOutlineMenuOpen size={30}/>}
        </IconButton>
      ) : null}
      {headerContent}
    </Toolbar>
  );

  // app-bar params
  const appBar = {
    position: 'fixed',
    color: 'inherit',
    elevation: 0,
    sx: {
      // borderBottom: `1px solid ${theme.palette.divider}`,
      top: developmentBarOffset, // Offset for development warning bar
      zIndex: 1200,
      width: isHorizontal
        ? '100%'
        : {
            xs: '100%',
            lg: drawerOpen
              ? `calc(100% - ${DRAWER_WIDTH}px)`
              : `calc(100% - ${MINI_DRAWER_WIDTH}px)`,
          },
    },
  };

  return (
    <>
      {!downLG ? (
        <AppBarStyled open={drawerOpen} {...appBar}>
          {mainHeader}
        </AppBarStyled>
      ) : (
        <AppBar {...appBar}>{mainHeader}</AppBar>
      )}
    </>
  );
};

export default Header;
